import { render, staticRenderFns } from "./base-checkbox-group.vue?vue&type=template&id=79ff4804"
import script from "./base-checkbox-group.ts?vue&type=script&lang=ts&external"
export * from "./base-checkbox-group.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports